import { useCallback, useEffect, useMemo, useState } from 'react';
import gte from 'semver/functions/gte';
import { Message } from '@hooks/use-browser-recorder';

const MIN_RECORDER_VERSION = '8.9.8';
const LEGACY_RECORDER_VERSION_PLACEHOLDER = 'RECORDER_VERSION';

export const useRecorderVersionCheck = () => {
  const [recorderVersion, setRecorderVersion] = useState<string | null>(null);

  const handlePong = useCallback((event: MessageEvent) => {
    if (
      event.data?.type === Message.INSTALLED_PONG_MESSAGE &&
      event.data?.version
    ) {
      setRecorderVersion(event.data.version);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', handlePong);

    (window.top ?? window).postMessage(
      {
        from: 'testsigma_web',
        type: Message.INSTALLED_PING_MESSAGE,
        content: 'Get installed status',
      },
      '*',
    );

    return () => {
      window.removeEventListener('message', handlePong);
    };
  }, [handlePong]);

  const isRecorderOutdated = useMemo(() => {
    if (!recorderVersion) return false;
    if (recorderVersion === LEGACY_RECORDER_VERSION_PLACEHOLDER) return true;
    try {
      return !gte(recorderVersion, MIN_RECORDER_VERSION);
    } catch {
      return false;
    }
  }, [recorderVersion]);

  return { isRecorderOutdated, recorderVersion };
};
